import type { OwnTransportIngredient } from '@apps/main/modules/recipe/ingredients/ownTransportIngredient';

import type { IngredientSerializer } from '..';

import { serializeOwnTransport } from './serialize';
import { deserializeOwnTransport } from './deserialize';

export const OwnTransportSerializer: IngredientSerializer<OwnTransportIngredient> =
  {
    serialize: (transport: OwnTransportIngredient): string =>
      serializeOwnTransport(transport),
    deserialize: (value: string): OwnTransportIngredient =>
      deserializeOwnTransport(value),
  };

export { OWN_TRANSPORT_INGREDIENT_SUFFIX } from './constants';
